<template>
  <div class="verify-mfa-code-form mode-selection">
    <div class="p-20" v-if="!showTrustBrowser">
      <div class="section-title mb-15">
        {{ $t('text.verification_required') }}
      </div>
      <div class="security-section">
        <div class="security-section-title">
          <svg-icon
            iconClass="security"
            class="w-40 h-40"
            className="security-icon"
          ></svg-icon>
          {{ $t('text.security_step_up') }}
        </div>
        <div>{{ $t('text.security_step_up_desc') }}.</div>
      </div>
      <div class="text-left mt-10 mb-20">
        {{ $t('text.we_have_sent_mfa_code_first_line') }}. <br />
        {{ $t('text.we_have_sent_mfa_code_second_line') }}.
      </div>
      <div class="text-left mb-5">{{ $t('text.enter_secure_code') }}</div>
      <div class="custom-input-group">
        <div
          v-for="(item, index) in mfaCodeArr"
          :key="index"
          class="custom-input custom-input-char"
        >
          <input
            v-model="item.character"
            :disabled="item.disabled"
            :id="'character' + index"
            :maxlength="1"
            @input="inputFinish(index)"
            @focus="adjust(index)"
            @keydown="inputDirection($event, index)"
            :class="!item.character ? 'no-value-input' : ''"
          />
        </div>
        <div class="text-left mt-5">
          <div :class="prompt.class">
            {{ prompt.text }}
          </div>
        </div>
        <div class="text-right">
          <span
            class="text-a cursor-pointer inline-block"
            @click="sendCode(true)"
            :loading="sendLoading"
            >{{ $t('text.resend_code') }}</span
          >
        </div>
      </div>
    </div>
    <div class="p-20 text-left" v-if="showTrustBrowser">
      <div class="section-title mb-15">
        {{ $t('text.trust_this_browser') }}?
      </div>
      <div>
        <div class="mb-10">{{ $t('text.trust_browser_first_line') }}.</div>
        <div>{{ $t('text.trust_browser_second_line') }}.</div>
      </div>
      <el-button class="wp-100 mt-30 save-btn" @click="trustBrowser()">{{
        $t('text.trust_this_browser')
      }}</el-button>
      <div class="text-center mt-15">
        <span class="text-a cursor-pointer inline-block" @click="notNow()">{{
          $t('text.not_now')
        }}</span>
      </div>
      <div class="mt-15">
        <i class="el-icon-warning mr-5 blue-font"></i>
        <span>{{ $t('text.browser_can_not_be_trust') }}.</span>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import _ from 'lodash'
import moment from 'moment'
export default {
  data() {
    return {
      activeInput: 0,
      mfaCodeArr: [
        { character: '', disabled: false },
        { character: '', disabled: false },
        { character: '', disabled: false },
        { character: '', disabled: false },
        { character: '', disabled: false },
        { character: '', disabled: false }
      ],
      verifyLoading: false,
      sendLoading: false,
      prompt: {
        text: '',
        class: ''
      },
      showTrustBrowser: false
    }
  },
  mounted() {
    this.sendCode(false)
    this.activeFirstInput()
  },
  methods: {
    activeFirstInput() {
      let dom = document.getElementById('character0')
      if (dom) dom.focus()
    },
    adjust(index) {
      let dom = document.getElementById('character' + this.activeInput)
      if (index !== this.activeInput && dom) {
        dom.focus()
      }
    },
    inputDirection(event, index) {
      let val = this.mfaCodeArr[index].character
      // Fallback key processing
      if (event.keyCode == 8 && val == '') {
        // Recalibrate
        this.activeInput = index - 1
        let dom = document.getElementById('character' + this.activeInput)
        if (dom) dom.focus()
      }
      if (event.keyCode != 8 && val != '') {
        this.activeInput = index + 1
        let dom = document.getElementById('character' + this.activeInput)
        if (dom) dom.focus()
      }
    },
    // The input boxes are interconnected
    inputFinish(index) {
      let specialRule = new RegExp(
        "[`~!@#$^&*()=_|+%{}':;',\\[\\].<>/?~@#￥……&*|{}]"
      )
      let str = this.mfaCodeArr[index].character
      if (specialRule.test(str)) {
        this.mfaCodeArr[index].character = ''
        return false
      }
      let val = this.mfaCodeArr[index].character

      // Automatically focus to the next input box
      this.activeInput = val ? index + 1 : index - 1
      let dom = document.getElementById('character' + this.activeInput)
      if (dom) dom.focus()

      // Automatically validate when the last character is entered
      if (this.activeInput === this.mfaCodeArr.length) {
        this.verifyCode()
      }
    },
    sendCode(isResend = false) {
      if (isResend) {
        this.sendLoading = true
      }
      ApiService.initializeMfa()
        .then(response => {
          this.sendLoading = false
          if (response.data.success) {
            if (isResend) {
              this.prompt = {
                text: '',
                class: ''
              }
              this.mfaCodeArr = [
                { character: '', disabled: false },
                { character: '', disabled: false },
                { character: '', disabled: false },
                { character: '', disabled: false },
                { character: '', disabled: false },
                { character: '', disabled: false }
              ]
              swal({
                icon: 'success',
                timer: 2000,
                title: this.$t('text.sent_successfully')
              })
              this.activeInput = 0
            }
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.sendLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    verifyCode() {
      let code = this.mfaCodeArr.map(item => item.character).join('')
      if (!code) {
        this.prompt = {
          text:
            this.$t('text.verification_failed') +
            ': ' +
            this.$t('text.please_enter_verification_code'),
          class: 'red-font'
        }
        return false
      }
      this.verifyLoading = true
      ApiService.verifyMfaCode(code)
        .then(response => {
          this.verifyLoading = false
          if (response.data.success) {
            this.handleVerifySuccess()
          } else {
            this.prompt = {
              text:
                this.$t('text.verification_failed') + ': ' + response.data.msg,
              class: 'red-font'
            }
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.verifyLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    handleVerifySuccess() {
      this.prompt = {
        text: this.$t('text.verification_passed'),
        class: 'green-font'
      }
      this.setVerifyMfaCodeCookie()
      this.showTrustBrowser = true
    },
    trustBrowser() {
      this.setTrustBrowserCookie()
      this.$emit('success')
    },
    notNow() {
      this.$emit('success')
    },
    setVerifyMfaCodeCookie() {
      let loggedIn = localStorage.getItem('user')
      if (loggedIn) {
        loggedIn = JSON.parse(loggedIn)
        if (!loggedIn.email) return false
        let verifyMfaCodeArr = localStorage.getItem('verifyMfaCodeArr')
          ? JSON.parse(localStorage.getItem('verifyMfaCodeArr'))
          : []

        // make sure the cookie in the browser expires every 90 days
        verifyMfaCodeArr.push({
          email: loggedIn.email,
          expireDate: moment()
            .add(90, 'days')
            .valueOf()
        })

        // If mfa is verified multiple times, the last data will be kept
        verifyMfaCodeArr = _.values(
          _.mapValues(_.groupBy(verifyMfaCodeArr, 'email'), group =>
            _.last(group)
          )
        )
        localStorage.setItem(
          'verifyMfaCodeArr',
          JSON.stringify(verifyMfaCodeArr)
        )
      }
    },
    setTrustBrowserCookie() {
      let loggedIn = localStorage.getItem('user')
      if (loggedIn) {
        loggedIn = JSON.parse(loggedIn)
        if (!loggedIn.email) return false
        let trustBrowserArr = localStorage.getItem('trustBrowserArr')
          ? JSON.parse(localStorage.getItem('trustBrowserArr'))
          : []

        // make sure the cookie in the browser expires every 90 days
        trustBrowserArr.push({
          email: loggedIn.email,
          expireDate: moment()
            .add(90, 'days')
            .valueOf()
        })

        // If mfa is verified multiple times, the last data will be kept
        trustBrowserArr = _.values(
          _.mapValues(_.groupBy(trustBrowserArr, 'email'), group =>
            _.last(group)
          )
        )
        localStorage.setItem('trustBrowserArr', JSON.stringify(trustBrowserArr))
      }
    }
  }
}
</script>

<style lang="scss">
.verify-mfa-code-form .custom-input-group .custom-input-char {
  width: calc((100% - 35px) / 6);
}
</style>
